import React from "react";
import nextId from "react-id-generator";
import { Link, useHistory } from "react-router-dom";
import { getAllJobs, getAppliedJobs } from "../../../../APIs/GetAPIs";
import { getAllSavedJobs } from "../../../../APIs/PostAPIS";
import { Images } from "../../../../Assets/0a-exporter";
import JobOpeningCard from "../../../Common/JobOpeningCard/JobOpeningCard";
import SimilarJobCard from "../../../Common/SimilarJobCard/SimilarJobCard";
import { MainContext } from "../../DashboardContext/Context";
import "./applied-jobs.style.scss";
export default function AppliedJobs() {
  const history = useHistory();
  const [headerList, setHeaderList] = React.useState(headerListStatic);
  const [selectedType, setSelectedType] = React.useState(headerListStatic[0]);
  const context = React.useContext(MainContext);
  const { userDetails, appliedJobs, savedJobs } = context;
  const [appliedJobsList, setAppliedJobsList] = React.useState([]);
  const [viewAll, setViewAll] = React.useState(false);
  const [currentJobList, setCurrentJobList] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [appliedLoader, setAppliedLoader] = React.useState(false);
  const [savedJobList, setSavedJobList] = React.useState(null);
  const [appliedPercentage, setAppliedPercentage] = React.useState(60);
  const setUpJObList = async () => {
    try {
      setLoading(true);
      let res = await getAppliedJobs(userDetails.user_id);
      if (res.data.statusCode === 200) {
        setAppliedJobsList(res.data.data);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  React.useEffect(() => {
    let token = localStorage.getItem("userToken");

    if ((userDetails !== null && !userDetails) || !token) {
      history.push("/login");
    }
  }, [userDetails]);

  const returnDate = (date) => {
    let temp = date.split("-");
    return `${temp[0]} ${months[parseInt(temp[1])]} ${temp[2]}${
      dateSuffix[temp[2] % 10]
    }`;
  };

  const setUpRecommendedJob = async (filters) => {
    // setCurrentJobList([]);
    try {
      let res = await getAllJobs(filters);
      if (res.data.statusCode === 200) {
        let temp = res.data.data.map((x) => {
          let match = savedJobs.findIndex((y) => {
            return y === x.jobId;
          });
          if (match == -1) {
            return { ...x };
          } else {
            return { ...x, saved: true };
          }
        });
        setCurrentJobList([...temp.slice(0,3)]);
      }
    } catch (error) {}
  };
  const setUpSavedJobList = async () => {
    // setSavedJobList([]);
    setLoading(true);
    try {
      let res = await getAllSavedJobs({
        jobTitle: "",
        city: "",
        country: "",
        jobCategory: "",
        custField4: "",
        jobDescription: "",
        start: "1",
        numOfRecords: "9",
        websitePublish: "",
        custField1: [""],
        jobType: [""],
        minSalary: "0",
        maxSalary: "100000000",
      });
      if (res.data.statusCode === 200) {
        let temp = res.data.data.map((x) => {
          return { ...x, saved: true };
        });
        setSavedJobList([...temp.slice(0,3)]);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  React.useEffect(() => {
    if (!userDetails) return;
    setUpSavedJobList();
  }, [userDetails]);
  React.useEffect(() => {
    if (!userDetails) return;
    if (userDetails?.candidate_relocate) {
      setUpRecommendedJob({
        jobTitle: "",
        city:
          userDetails?.candidate_location?.[0]?.location_name ||
          userDetails?.candidate_current_location,
        country: "",
        jobCategory: "",
        custField4: "",
        jobDescription: "",
        start: "1",
        numOfRecords: "9",
        websitePublish: "",
        custField1: [""],
        jobType: [""],
        minSalary: "0",
        maxSalary: "100000000",
      });
    } else {
      setUpRecommendedJob({
        jobTitle: "",
        city: userDetails.candidate_current_location || "",
        country: "",
        jobCategory: "",
        custField4: "",
        jobDescription: "",
        start: "1",
        numOfRecords: "9",
        websitePublish: "",
        custField1: [""],
        jobType: [""],
        minSalary: "0",
        maxSalary: "100000000",
      });
    }
  }, [userDetails]);
  React.useEffect(() => {
    headerList[0] = { ...headerList[0], count: appliedJobs.length };
    setHeaderList([...headerList]);
  }, [appliedJobs]);

  React.useEffect(() => {
    if (!userDetails) return;
    setUpJObList();
  }, [userDetails]);

  React.useEffect(() => {
    if (!userDetails) return;
    let count = 0;
    if (userDetails?.candidate_resume) {
      count = count + 20;
    }
    if (userDetails?.candidate_employment.length) {
      count = count + 20;
    }
    if (userDetails?.candidate_qualification.length) {
      count = count + 20;
    }
    count = count + 40;
    setAppliedPercentage(count);
  }, [userDetails]);

  return (
    <div className="applied-jobs-main">
      <div className="applied-jobs-search-wrapper">
        <img src={Images.blueDotsTopLeft} />
        <img src={Images.blueDotsBottomRight} />
        <div>
          <input placeholder="Keywords, Job Location, Job type" />
          <button>Search</button>
        </div>
      </div>
      <section className="applied-jobs-section">
        <div className="ajm-profile">
          <div className="ajm-profile-card">
            <header>
              <p>
                Last Updated on:{" "}
                <b>
                  {userDetails &&
                    returnDate(userDetails?.updatedAt?.split("T")[0])}
                </b>
              </p>
              <button>
                <img src={Images.penIcon} />
              </button>
            </header>
            <label>
              <img
                src={
                  userDetails?.candidate_img ||
                  "https://img.icons8.com/office/48/000000/user-male-skin-type-5.png"
                }
                className="dp"
              />
              <button>
                <img src={Images.blueCamera} />
              </button>
            </label>
            <h5>{userDetails?.candidate_full_name}</h5>
            <p>{userDetails?.candidate_current_location}</p>
            <div className="completion">
              <div className="completion-above">
                <h6>Profile Completion</h6>
                <h6>{appliedPercentage}%</h6>
              </div>
              <progress value={appliedPercentage} max="100" />
            </div>
            {userDetails?.candidate_qualification.length ? (
              ""
            ) : (
              <div className="pc-text">
                <p>Education details</p>
                <span>
                  <Link to="/register/qualification">Add now</Link>{" "}
                </span>
              </div>
            )}
            {!userDetails?.candidate_employment.length ? (
              <div className="pc-text">
                <p>Employment details</p>
                <span>
                  <Link to="/register/resume">Add now</Link>
                </span>
              </div>
            ) : (
              ""
            )}
            {!userDetails?.candidate_resume ? (
              <div className="pc-text">
                <p>Add Resume</p>
                <span>
                  <Link to="/register/employment">Add now</Link>
                </span>
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="ajmp-institutes">
            <h5>Top Institutes Hiring</h5>
            <div className="institutes-wrapper">
              {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((obj) => (
                <div>
                  <span>
                    <img src={Images.menTree} />
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="assistance-wrapper">
            <img src={Images.techSupport} />
            <div>
              <h6>Do you need assistance?</h6>
              <p>React out to us</p>
            </div>
            <button>+91 91488 81795</button>
          </div>
        </div>
        <div className="ajm-left">
          <header className="ajml-header">
            {headerList.map((obj) => (
              <div
                onClick={() => setSelectedType(obj)}
                key={obj.keyId}
                className={`ajml-card-wrapper ${
                  obj.id === selectedType.id ? "selected-type" : ""
                }`}
              >
                <div className="ajmlcw-left">
                  <img src={obj.icon} />
                  <p>{obj.name}</p>
                </div>

                <div className="ajmlcw-right">{obj.count || "0"}</div>
              </div>
            ))}
          </header>
          <section className="interviewed-section">
            <header className="is-header">
              <h5>My Applied Jobs</h5>
            </header>
        
            <div className="job-applied-cards-wrapper">
              {loading ? (
                [1, 2].map((x) => <div className="jac-loader"></div>)
              ) : !appliedJobsList.length ? (
                <div className="job-applied-card">
                  <h5>No Jobs Applied</h5>
                </div>
              ) : (
                appliedJobsList.slice(0, viewAll ? 100000000 : 2).map((obj) => (
                  <div className="job-applied-card">
                    <div className="jac-left">
                      <div>
                        <p>{obj?.clientName || "NA"}</p>
                        <span>{obj?.location || "NA"}</span>
                      </div>
                      <button>Round 1</button>
                    </div>
                    {/* <div className="jac-right">
                      <p>10 Aug 2021</p>
                      <span>0:30 AM</span>
                    </div> */}
                  </div>
                ))
              )}
            </div>
            {appliedJobsList.length > 2 ? (
              <div onClick={() => setViewAll(!viewAll)} className="is-footer">
                {viewAll ? (
                  <p>Hide Jobs</p>
                ) : (
                  <>
                    <img src="https://img.icons8.com/ios/96/000000/expand-arrow--v2.png" />
                    <p>View {appliedJobsList.length - 2} more job</p>
                  </>
                )}
              </div>
            ) : (
              ""
            )}
          </section>
          <header className="ajml-r-header">
            <h5>Recommended Jobs</h5>
            <Link to="/user/list/recommended-jobs">View All</Link>
          </header>
          <section className="ajml-body">
            {!currentJobList
              ? [1, 2, 3].map((x) => (
                  <div className="ajm-job-card-loader">
                    <div />
                  </div>
                ))
              : currentJobList.slice(0, 3).map((obj) => (
                  <div className="ajm-job-card-wrapper">
                    <JobOpeningCard data={obj} applied={true} />
                  </div>
                ))}
          </section>
          <header className="ajml-r-header">
            <h5>Saved Jobs</h5>
            <Link to="/user/list/saved-jobs">View All</Link>
          </header>
          <section className="ajml-body">
            {!savedJobList
              ? [1, 2, 3].map((x) => (
                  <div className="ajm-job-card-loader">
                    <div />
                  </div>
                ))
              : savedJobList.slice(0, 3).map((obj) => (
                  <div className="ajm-job-card-wrapper">
                    <JobOpeningCard data={obj} applied={true} />
                  </div>
                ))}
          </section>
        </div>
      </section>
    </div>
  );
}
const headerListStatic = [
  {
    keyId: nextId(),
    id: "all",
    name: "Total Job Application",
    icon: Images.blueCorrect,
  },
  {
    keyId: nextId(),
    id: "review",
    name: "Applications under review",
    icon: Images.cvLogo,
  },
  {
    keyId: nextId(),
    id: "progress",
    name: "Interview in progress",
    icon: Images.interviewLogo,
  },
  {
    keyId: nextId(),
    id: "archived",
    name: "Archived Applications",
    icon: Images.letterInBox,
  },
];

const dateSuffix = {
  0: "th",
  1: "st",
  2: "nd",
  3: "rd",
  4: "th",
  5: "th",
  6: "th",
  7: "th",
  8: "th",
  9: "th",
};

const months = {
  1: "Jan",
  2: "Feb",
  3: "March",
  4: "April",
  5: "May",
  6: "June",
  7: "July",
  8: "Aug",
  9: "Sept",
  10: "Oct",
  11: "Nov",
  12: "Dec",
};
